// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3l9FX","buttons":"SendReceipts_buttons__3p_gI","email":"SendReceipts_email__2U-sY","bookApptTitle":"SendReceipts_bookApptTitle__BA1ez"};